import { Component, signal } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Sidebar } from '../../shared/components/sidebar/sidebar';
import { Navbar } from '../../shared/components/navbar/navbar';
import { TextInput } from '../../shared/components/text-input/text-input';
import { Button } from '../../shared/components/button/button';

@Component({
  selector: 'app-settings',
  standalone: true,
  imports: [CommonModule, Sidebar, Navbar, TextInput, Button],
  templateUrl: './settings.html',
  styleUrl: './settings.css'
})
export class Settings {
  // ⚠️ TEMP: dummy data — replace with real user/session/connector data when APIs are ready
  fullName = signal('Jane Acme');
  workEmail = signal('jane@acme.com');
  twoFactorEnabled = signal(false);

  sessions = [
    { device: 'MacBook Pro · Chrome 120', location: 'New York, US', status: 'Current session', active: true },
    { device: 'iPhone 15 · Safari', location: 'New York, US', status: '2 hours ago', active: false }
  ];

  onUpdateProfile() {
    // TODO: wire profile update API when available
  }

  onChangePassword() {
    // TODO: open change-password flow
  }

  toggleTwoFactor() {
    this.twoFactorEnabled.set(!this.twoFactorEnabled());
  }

  onSignOutSession(index: number) {
    // TODO: wire sign-out-session API
  }
}